import * as React from 'react';

const SvgIconHerbivore = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={25} height={25} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M19.831 10.697a8.941 8.941 0 00-2.51-3.6 8.937 8.937 0 00-3.6-2.511 2.993 2.993 0 00-3.678 1.538S3.554 16.361 1.146 21.263a1.5 1.5 0 002 2c4.9-2.41 15.14-8.9 15.14-8.9a3 3 0 001.545-3.666z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.32 7.094l3.203-3.202M18.741 8.657l4.672-.813M15.757 5.673L16.57 1M10.036 6.134l3.591 3.591M4.408 15.355l2.856 2.856M10.977 13.438l3.38 3.381"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconHerbivore;
